import moment from "moment";
import Button from "./Button";
import Box from "@mui/material/Box";
import constants from "../constants";
import InfoSvg from "../Svg/InfoSvg";
import DatePicker from "react-datepicker";
import PinSvgIcon from "../Svg/PinSvgIcon";
import Popover from "@mui/material/Popover";
import Radio from "./CommonComponents/Radio";
import RejectHooks from "../Hooks/RejectHooks";
import CloseSvgIcon from "../Svg/CloseSvgIcon";
import Checkbox from "./CommonComponents/Checkbox";
import AlertContext from "../context/AlertContext";
import CommentsHooks from "../Hooks/CommentsHooks";
import ImageLogoSvgIcon from "../Svg/ImageLogoSvgIcon";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import React, { useContext, useEffect, useState } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function Reject() {
  const Alert = useContext(AlertContext);

  // console.log("Alert.rejectData", Alert.rejectData);
  // console.log("reject topic name : ", Alert.rejectData?.topicName);

  const {
    newTime,
    getTime,
    rejectOption,
    setGivenTime,
    minExtendDate,
    rejectConfirm,
    extensionDate,
    getDueDateLogic,
    setRejectConfirm,
    minExtendDateValue,
    rejectOptionChange,
    extensionDateChange,
    handleResubmissionReject,
  } = RejectHooks();

  const {
    changeComments,
    handleCommentAttachment,
    handleDeleteCommentAttachment,
  } = CommentsHooks();

  let [conf, setconf] = useState("");
  let [mapcopy, setmapcopy] = useState(null);
  let [canretake, setcanretake] = useState(false);
  let [extension, setExtension] = useState(false);

  useEffect(() => {
    if (minExtendDateValue) {
      getDueDateLogic();
    }
  }, [minExtendDateValue]);

  useEffect(() => {
    let canretake = true;

    const map1 = new Map();

    let str = "";

    if (
      (Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.SAQ ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.LAQ ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ_MULTI ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ_SINGLE ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
        Alert.showBreadCrumbsData.type ===
          constants.libTypeIds.CODING_SNIPPET ||
        Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL) &&
      (Alert.rejectData?.remaingQnCount.length > 0 ||
        Alert.rejectData?.isFixedQn)
    ) {
      for (let i = 0; i < Alert.rejectData.remaingQnCount.length; i++) {
        if (
          map1.has(
            Alert.rejectData.remaingQnCount[i].tname +
              Alert.rejectData.remaingQnCount[i].complexityid,
          )
        ) {
          let temp = map1.get(
            Alert.rejectData.remaingQnCount[i].tname +
              Alert.rejectData.remaingQnCount[i].complexityid,
            {
              count: Alert.rejectData.remaingQnCount[i].qnCount,
              avaliable: Alert.rejectData.remaingQnCount[i].qnAvailable,
            },
          );

          temp.count = temp.count + Alert.rejectData.remaingQnCount[i].qnCount;

          if (temp.avaliable >= temp.count) {
            temp.comment = "yes";
          } else {
            temp.comment = "no";
          }

          map1.set(
            Alert.rejectData.remaingQnCount[i].cname +
              Alert.rejectData.remaingQnCount[i].complexityid,
            temp,
          );
        } else {
          let comm;

          if (
            Alert.rejectData.remaingQnCount[i].qnAvailable >=
            Alert.rejectData.remaingQnCount[i].qnCount
          ) {
            comm = "yes";
          } else {
            comm = "no";
          }

          map1.set(
            Alert.rejectData.remaingQnCount[i].tname +
              Alert.rejectData.remaingQnCount[i].cname,
            {
              comment: comm,
              topic: Alert.rejectData.remaingQnCount[i].tname,
              count: Alert.rejectData.remaingQnCount[i].qnCount,
              complexity: Alert.rejectData.remaingQnCount[i].cname,
              avaliable: Alert.rejectData.remaingQnCount[i].qnAvailable,
            },
          );
        }
      }

      if (Alert.rejectData.isFixedQn) {
        canretake = true;
      } else {
        for (const [, value] of map1) {
          if (value.comment === "yes") {
            canretake = true;
          } else {
            canretake = false;
          }
        }
      }
    } else {
      canretake = false;
    }

    if (
      Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_CHALLENGE
    ) {
      map1.set(
        Alert.showBreadCrumbsData.topicName + Alert.rejectData.complexityid,
        {
          count: 1,
          topic: Alert.showBreadCrumbsData.topicName,
          avaliable: Alert.rejectData.remainingQnLibrary,
          comment: Alert.rejectData.remainingQnLibrary > 0 ? "yes" : "no",
          complexity:
            Alert.rejectData.complexityid === 1
              ? "Easy"
              : Alert.rejectData.complexityid === 2
              ? "Medium"
              : "Difficult",
        },
      );

      if (Alert.rejectData.isFixedQn === 1) {
        canretake = true;
      } else if (
        Alert.rejectData.isFixedQn === 0 &&
        Alert.rejectData.remainingQnLibrary > 0
      ) {
        canretake = true;
      } else {
        canretake = false;
      }
    }

    setmapcopy(map1);
    setconf(str);
    setcanretake(canretake);
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;
  console.log(
    " Alert.showBreadCrumbsData",
    Alert.showBreadCrumbsData,
    "Alert.rejectData",
    Alert.rejectData,
  );

  const showVersionOption = Alert.rejectData?.hasAnyNewVersion;

  return (
    <div className="rejectMainContainer">
      <Box
        sx={{
          p: 4,
          boxShadow: 2,
          height: "85vh",
          borderRadius: 3,
          bgcolor: "#FFFFFF",
          overflow: "scroll",
          width:
            Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
              ? "40vw"
              : "60vw",
        }}
      >
        {Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT && (
          <>
            <div className="rejectHeaderForAssignment">
              <InfoSvg component="rejectForAssignment" />
              <div className="rejectInstructionForAssignment">
                If the assignment is rejected by you, the learner can resubmit
                this assignment before the due date.
                <p>
                  You can also add a comment stating the reason for rejection
                  and resubmission.
                </p>
              </div>
            </div>

            <div className="rejectCommentsForAssignment">
              <div className="rejectCommentsForAssignmentTextAreaDiv">
                <TextareaAutosize
                  minRows={7}
                  id={"inputs" + 1}
                  key={"inputs" + 1}
                  input={Alert.comment}
                  value={Alert.comment}
                  onChange={changeComments}
                  className="rejectCommentsForAssignmentTextArea"
                  placeholder="Enter your comment for the trainee."
                />
                {Alert.showBreadCrumbsData.type ===
                  constants.libTypeIds.ASSIGNMENT &&
                  Alert.commentAttachment.map((attachment) => (
                    <div
                      key={attachment.id}
                      className="rejectCommentsForAssignmentFileUpload"
                    >
                      <div className="rejectCommentsForAssignmentFileUploadInnerDiv">
                        <ImageLogoSvgIcon />
                        <div className="rejectCommentsForAssignmentFileUploadFileName">
                          {attachment.file.name}
                        </div>

                        <div className="rejectCommentsForAssignmentFileUploadFileSize">
                          {attachment.hasOwnProperty("file") &&
                          attachment.file.size !== undefined &&
                          (attachment.file.size / 1e6).toFixed(2) > 1
                            ? `${(attachment.file.size / 1e6).toFixed(2)} MB`
                            : `${(attachment.file.size / 1024).toFixed(2)} KB`}
                        </div>
                      </div>
                      <div className="rejectCommentsForAssignmentCloseSvgIcon">
                        <CloseSvgIcon
                          onClick={() =>
                            handleDeleteCommentAttachment(attachment.id)
                          }
                        />
                      </div>
                    </div>
                  ))}

                {Alert.showBreadCrumbsData.type ===
                  constants.libTypeIds.ASSIGNMENT && (
                  <div className="rejectCommentsForAssignmentAttachmentDiv">
                    <PinSvgIcon />
                    <input
                      multiple
                      type="file"
                      accept="image/*"
                      onChange={handleCommentAttachment}
                      className="rejectCommentsForAssignmentAttachmentInput"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="rejectCommentsForAssignmentFooter">
              <div className="rejectCommentsForAssignmentFooterCheckBoxDiv">
                <Checkbox
                  checked={extension}
                  onChange={(value) => setExtension(value)}
                />
                <span className="rejectCommentsForAssignmentFooterCheckBoxLabel">
                  Extend deadline
                </span>
              </div>
              <div className="rejectTestExtendDateDivLabel">
                Set extended deadline:
              </div>
              <DatePicker
                showIcon
                showTimeInput
                disabled={!extension}
                timeInputLabel="Time:"
                className="rejectTestDatePicker"
                dateFormat="dd/MMM/yyyy h:mm aa"
                minDate={new Date(minExtendDate)}
                selected={new Date(extensionDate)}
                onChange={(date) => extensionDateChange(date)}
              />
            </div>
            <div className="rejectTestFooterButtonDiv">
              <Button
                size={"sm"}
                onClick={() => {
                  Alert.setIsLoaded(false);
                  Alert.setShowReject(false);
                }}
                hierarchy={{
                  buttonText: "Cancel",
                  type: "secondaryGrey",
                }}
              />

              <Button
                size={"sm"}
                destructive={true}
                disable={!extension}
                onClick={handleResubmissionReject}
                hierarchy={{
                  type: "primary",
                  buttonText: "Reject",
                }}
              />
            </div>
          </>
        )}

        {Alert.showBreadCrumbsData.type !== constants.libTypeIds.ASSIGNMENT && (
          <div className="rejectTestMainContainer">
            <div className="rejectTestMainContainerInnerDiv">
              <table>
                <thead>
                  <tr>
                    <th colSpan={2}>Timing Summary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="rejectTestTableLabel">Due Date </td>
                    <td className="rejectTestTableValue">
                      {moment(Alert.showBreadCrumbsData.learnerDueDate).format(
                        "MMMM Do YYYY, h:mm a",
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="rejectTestTableLabel">Test Duration </td>
                    <td className="rejectTestTableValue">
                      {getTime("duration")}
                    </td>
                  </tr>
                  <tr>
                    <td className="rejectTestTableLabel">Time Left</td>
                    <td className="rejectTestTableValue">{getTime()}</td>
                  </tr>
                  {Alert.showBreadCrumbsData.type ===
                    constants.libTypeIds.CODING_CHALLENGE && (
                    <tr>
                      <td className="rejectTestTableLabel">No.of Retakes </td>
                      <td className="rejectTestTableValue">
                        {Alert.rejectData.replacedQnTimes || "-"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="rejectTestInnerDiv">
              <div className="rejectTestOptionDiv">
                <div className="rejectTestOptionInnerDiv">
                  <div className="rejectTestOptionInnerDivHeader">
                    Reject or Extend
                  </div>
                  <div className="rejectTestOptionLabel">
                    <Radio
                      size="sm"
                      text="Reject and score NIL"
                      value="scrnil"
                      checked={rejectOption === "scrnil"}
                      onChange={(value) => rejectOptionChange(value)}
                    />
                  </div>
                  <div className="rejectTestOptionLabelForGivenTime">
                    <Radio
                      size="sm"
                      value="givetime"
                      text="Extend with given time"
                      checked={rejectOption === "givetime"}
                      onChange={(value) => rejectOptionChange(value)}
                    />
                    <input
                      type="number"
                      value={newTime}
                      onChange={(e) => setGivenTime(e)}
                      className="rejectTestWithGivenTime"
                      disabled={rejectOption !== "givetime"}
                    />{" "}
                    minutes
                  </div>
                  {Alert.showBreadCrumbsData.type !==
                    constants.libTypeIds.ASSIGNMENT && (
                    <>
                      <div className="rejectTestOptionLabel">
                        <Radio
                          size="sm"
                          value="extsam"
                          text="Extend with remaining time"
                          checked={rejectOption === "extsam"}
                          disabled={
                            Alert.rejectData.timeleft === 0 ||
                            Alert.rejectData.timeleft == null
                          }
                          onChange={(value) => rejectOptionChange(value)}
                        />
                        <span className="rejectTestWithRemainingTime">
                          {Alert.rejectData.timeleft == null
                            ? "( 00 )"
                            : "( " +
                              Math.trunc(Alert.rejectData.timeleft / 60) +
                              " )" +
                              " mins (" +
                              (Alert.rejectData.timeleft % 60) +
                              ") s"}
                        </span>
                      </div>
                      <div className="rejectTestOptionLabel">
                        <Radio
                          size="sm"
                          value="newVersion"
                          text="Retake with new version"
                          checked={rejectOption === "newVersion"}
                          disabled={
                            Alert.rejectData.timeleft === 0 ||
                            Alert.rejectData.timeleft == null ||
                            !showVersionOption
                          }
                          onChange={(value) => rejectOptionChange(value)}
                        />
                      </div>
                      {canretake && (
                        <div className="rejectTestOptionLabel">
                          <Radio
                            size="sm"
                            text={
                              (Alert.showBreadCrumbsData.type ===
                                constants.libTypeIds.CODING_CHALLENGE &&
                                Alert.rejectData.isFixedQn === 1) ||
                              (Alert.showBreadCrumbsData.type !==
                                constants.libTypeIds.CODING_CHALLENGE &&
                                Alert.rejectData.isFixedQn)
                                ? "Retake same question ( fixed question )"
                                : "Retake with new questions"
                            }
                            value="restart"
                            checked={rejectOption === "restart"}
                            disabled={!canretake}
                            onChange={(value) => rejectOptionChange(value)}
                          />
                          <>
                            <InfoSvg component="reject" onClick={handleClick} />
                            <Popover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              disableRestoreFocus
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                            >
                              <table className="popup-table">
                                <tr>
                                  <th>Topic</th>
                                  <th>Complexity</th>
                                  <th>Required</th>
                                  <th>Avaliable</th>
                                </tr>
                                {mapcopy !== null &&
                                  [...mapcopy.keys()].map((key) => (
                                    <tr key={key}>
                                      <td>{mapcopy.get(key).topic}</td>
                                      <td>{mapcopy.get(key).complexity}</td>
                                      <td>{mapcopy.get(key).count}</td>
                                      <td>
                                        {" "}
                                        <span
                                          className={mapcopy.get(key).comment}
                                        >
                                          {mapcopy.get(key).avaliable}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                              </table>
                            </Popover>
                          </>
                        </div>
                      )}

                      {!canretake && (
                        <div className="rejectTestOptionLabel">
                          <Radio
                            size="sm"
                            text={
                              Alert.showBreadCrumbsData.type ===
                                constants.libTypeIds.CODING_CHALLENGE &&
                              Alert.rejectData.isFixedQn === 1
                                ? "Retake same question ( fixed question )"
                                : "Retake with new questions"
                            }
                            value="restart"
                            checked={rejectOption === "restart"}
                            disabled={!canretake}
                            onChange={(value) => rejectOptionChange(value)}
                          />
                          {conf === "" && (
                            <>
                              {" "}
                              <ErrorOutlineIcon
                                onClick={handleClick}
                                onMouseEnter={handleClick}
                              />
                              <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                              >
                                <table className="popup-table">
                                  <tr>
                                    <th>Topic</th>
                                    <th>Complexity</th>
                                    <th>Required</th>
                                    <th>Avaliable</th>
                                  </tr>
                                  {mapcopy !== null &&
                                    [...mapcopy.keys()].map((key) => (
                                      <tr key={key}>
                                        <td>{mapcopy.get(key).topic}</td>
                                        <td>{mapcopy.get(key).complexity}</td>
                                        <td>{mapcopy.get(key).count}</td>
                                        <td>
                                          {" "}
                                          <span
                                            className={mapcopy.get(key).comment}
                                          >
                                            {mapcopy.get(key).avaliable}
                                          </span>
                                        </td>
                                      </tr>
                                    ))}
                                </table>
                              </Popover>
                            </>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
                {Alert.showBreadCrumbsData.type ===
                  constants.libTypeIds.ASSIGNMENT && (
                  <div className="rejectTestOptionLabel">
                    <Radio
                      size="sm"
                      text="Extend Duedate"
                      value="extend"
                      checked={rejectOption === "extend"}
                      onChange={(value) => rejectOptionChange(value)}
                    />
                  </div>
                )}
              </div>

              <div className="rejectTestExtendDateDiv">
                <div className="rejectTestExtendDateDivLabel">
                  Select extended Deadline
                </div>
                <div className="comments-score-section-score-reject-box-score-extend-datetime-des-mcq">
                  <div className="codingDateLabel">
                    <div className="rejectTestDatePickerDiv">
                      <DatePicker
                        showIcon
                        showTimeInput
                        timeInputLabel="Time:"
                        className="rejectTestDatePicker"
                        dateFormat="dd/MMM/yyyy h:mm aa"
                        minDate={new Date(minExtendDate)}
                        selected={new Date(extensionDate)}
                        onChange={(date) => extensionDateChange(date)}
                        disabled={
                          (rejectOption === "" ||
                            rejectOption === "scrnil" ||
                            rejectOption !== "extend") &&
                          rejectOption !== "restart" &&
                          rejectOption !== "extsam" &&
                          rejectOption !== "givetime"
                        }
                        placeholderText={
                          rejectOption === "" || rejectOption === "scrnil"
                            ? "Disabled"
                            : "Select date"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="rejectTestFooter">
                <div className="rejectTestFooterConfirmationDiv">
                  <Checkbox
                    size="sm"
                    text="Confirm selection"
                    checked={rejectConfirm}
                    disabled={rejectOption === ""}
                    onChange={(value) => setRejectConfirm(value)}
                  />
                </div>

                <div className="rejectTestFooterButtonDiv">
                  <Button
                    size={"sm"}
                    onClick={() => {
                      Alert.setShowReject(false);
                    }}
                    hierarchy={{
                      buttonText: "Cancel",
                      type: "secondaryGrey",
                    }}
                  />
                  <Button
                    size={"sm"}
                    destructive={true}
                    disable={!rejectConfirm}
                    onClick={handleResubmissionReject}
                    hierarchy={{
                      type: "primary",
                      buttonText: "Reject",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Box>
    </div>
  );
}
